import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { plantillas, proyectos } from '../data/landing';
const pasos = [{
  numero: '1',
  titulo: 'Imprimís el patrón'
}, {
  numero: '2',
  titulo: 'Marcás las perforaciones'
}, {
  numero: '3',
  titulo: 'Elegís los colores'
}, {
  numero: '4',
  titulo: 'Bordás el diseño'
}, {
  numero: '5',
  titulo: 'Terminás tu pieza'
}];
export function Proceso() {
  return <section className="w-full bg-white py-12 sm:py-20" aria-labelledby="proceso-titulo" data-id="element-160" data-mp="3i94y5b3wg2bo">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-161" data-mp="3mazyode0aboe">
        <Reveal data-id="element-162" data-mp="3r319duvizucb">
          <h2 id="proceso-titulo" className="mx-auto max-w-2xl text-center font-serif text-2xl leading-snug text-borgona sm:text-4xl" data-id="element-163" data-mp="3r4kq1ml3g7em">
            De una simple hoja de papel…{' '}
            <em className="font-script not-italic text-terracota" data-id="element-164" data-mp="4x48kulvkz8g">
              …a una pieza hecha completamente por vos.
            </em>
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-165" data-mp="3g6oj8rdadydk">
          <div className="mt-8 grid items-center gap-4 sm:grid-cols-[1fr_auto_1fr] sm:gap-6" data-id="element-166" data-mp="3g6yaeia2ibku">
            <figure className="overflow-hidden rounded-3xl border border-rosa-100 bg-crema shadow-tarjeta" data-id="element-167" data-mp="3b7byqd9w13e5">
              <img src={plantillas[0].imagen} alt="Hoja con el patrón impreso, antes de bordar" className="aspect-[4/3] w-full object-cover" data-id="element-168" data-mp="369jvin3sluun" />
              <figcaption className="px-4 py-3 text-center font-sans text-sm font-bold uppercase tracking-[0.16em] text-suave" data-id="element-169" data-mp="32900pq6oz3bo">
                Antes
              </figcaption>
            </figure>

            <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-frambuesa text-white shadow-suave" data-id="element-170" data-mp="3u063kedsrf4n">
              <ArrowRightIcon className="h-6 w-6 rotate-90 sm:rotate-0" aria-hidden="true" data-id="element-171" data-mp="3l613d4crwrcg" />
            </span>

            <figure className="overflow-hidden rounded-3xl border border-rosa-100 bg-crema shadow-tarjeta" data-id="element-172" data-mp="lijegepal9cy">
              <img src={proyectos[0].imagen} alt="Tarjeta terminada con un ramo bordado a mano" className="aspect-[4/3] w-full object-cover" data-id="element-173" data-mp="gqi6h4z5q4sq" />
              <figcaption className="px-4 py-3 text-center font-sans text-sm font-bold uppercase tracking-[0.16em] text-frambuesa" data-id="element-174" data-mp="2b1hwtg966mjy">
                Después
              </figcaption>
            </figure>
          </div>
        </Reveal>

        <Reveal delay={0.15} data-id="element-175" data-mp="2686ofaoplxpx">
          <ol className="mx-auto mt-10 flex max-w-xl flex-col gap-3" data-id="element-176" data-mp="267dpgvvzscic">
            {pasos.map(paso => <li key={paso.numero} className="flex items-center gap-4 rounded-2xl border border-rosa-100 bg-crema px-5 py-4" data-id="element-177" data-mp="1s7vw037r4b2n">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-oliva font-sans text-base font-bold text-white" data-id="element-178" data-mp="1x9bhfwducjlk">
                  {paso.numero}
                </span>
                <span className="font-sans text-base font-semibold leading-snug text-tinta sm:text-lg" data-id="element-179" data-mp="1na2on6uppb0s">
                  {paso.titulo}
                </span>
              </li>)}
          </ol>
        </Reveal>
      </div>
    </section>;
}